import DropUpload from "../../../Submission/BatchUpload/DropUpload";
import React from "react";
import { Position } from "puzzle";
import TemplateLoader from "../../../TemplateLoader";
import _ from "lodash";
import { FILE } from "./ReportDialog/Types";
import { STATE } from "../../../Submission/BatchUpload/Types";
import { REPORT_DATA, ERROR_DATA } from "./Types";
import { SUBMISSION } from "../../../Abstract/Grid/Types";

type PROPS = {
  supplierView: boolean,
  submissionData: SUBMISSION
}

class UploadDialog extends DropUpload<PROPS> {
  public state: STATE = {
    ...this.state,
    allowUpload: true,
    extractArchive: true,
    extractArchiveEnabled: true,
    taskId: ''
  };

  static defaultProps = {
    files: [],
    isCollapsed: false,
    isDisabled: false,
    multiBatchDialog: false,
    showUploadStatus: false,
    uploadActionName: 'uploadDialogCollectReports',
    supplierView: false
  };

  uploadData: File[] = [];
  groupedResponseData: FILE[][] = [];
  additionalProps: any = {
    ipcEnabled: false,
    promoteDemoteEnabled: false
  };
  errors: string[] = []; //errors on upload

  /**
   * Returns list of all files that are currently being uploaded
   */
  createUploadedFilesList = () => {
    return <TemplateLoader message={this.translate('uploadingIndicator')} />
  };

  /**
   * Enables upload button and drag upload if criteria is satisfied
   */
  enableUpload = (projectId: number) => {
    //override
    //don't delete, need to be empty
  };

  /**
   * Collects report data after every successfully ping
   * @param data
   */
  collectResponseData = (data: REPORT_DATA) => {
    let fileReports = data.uploadReportsDto;
    if (data.ipcEnabled) {
      this.additionalProps.ipcEnabled = data.ipcEnabled;
    }
    this.additionalProps.promoteDemoteEnabled = data.promoteDemoteEnabled;
    let groupedByDocuments = _.groupBy(fileReports, (item: FILE) => {
      return `${item.documentName}_${item.targetLanguageName}`
    });
    let keys = Object.keys(groupedByDocuments);
    keys.forEach((key: string) => {
      let items = groupedByDocuments[key];
      if (key === 'null_null') { //null_null key is for ignored files
        let mappedItems = Array.from(items, (item) => [item]);
        this.groupedResponseData = this.groupedResponseData.concat(mappedItems);
      } else {
        this.groupedResponseData.push(items);
      }
    });
  };

  /**
   * Collects report data after every failed pinging request
   * @param data
   */
  collectUploadErrors = (data: ERROR_DATA) => {
    this.errors = this.errors.concat(_.get(data, 'messages[0]'));
  };

  /**
   * @override
   */
  getDropFilesMessage = () => {
    return this.translate('dropZoneText')
  };

  /**
   * @inheritDoc
   */
  childModuleDidMount = () => {
    if (this.props.files.length) {
      this.startFileUpload(this.props.files)
    }
  }

  /**
   * @override
   */
  reset = () => this.setState({
    allowUpload: true,
    deletedFiles: [],
    dragging: false,
    droppedFiles: [],
    extractArchive: true,
    extractArchiveEnabled: true,
    failed: 0,
    progresses: {},
    projectId: 0,
    submissionFolder: '',
    uploaded: 0,
    uploadFiles: [],
    zipUploadInProgress: false
  });

  /**
   * Set taskId data
   * @param {string} taskId
   */
  setTaskId = (taskId: string) => {
    this.setState({ taskId });
  }

  /**
   * @override
   */
  startFileUpload = (files: FileList) => {
    let { uploadFiles, extractArchive } = this.state;
    if (files) {
      this.uploadData = Array.from(files);
    }

    let uploadItem: any = !!this.uploadData.length && this.uploadData.splice(0, 1)[0];
    if (uploadItem) {
      let uploadParams: any = {
        file: uploadItem,
        extractArchive
      };

      if (this.props.supplierView && this.props.submissionData) {
        uploadParams = {
          ...uploadParams,
          taskId: this.props.submissionData.taskId
        }
      }

      let requestParams = {
        uploadParams,
        uploadFiles
      };

      this.setState({
        dragging: false,
        droppedFiles: this.state.droppedFiles.concat(uploadItem), //just for proposes of showing mask
      }, () => {
        this.dispatch(this.props.uploadActionName, Position.end, requestParams);
      });
    } else {
      let uploadedTargetIds = _.flatten(this.groupedResponseData).reduce((array: number[], item: any) => {
        const additionalCondition = this.additionalProps.ipcEnabled ? item.autoCompleted : true;
        if (item.fileUploadStatus === 'UPLOADED' && additionalCondition) {
          array.push(item.targetId);
        }
        return array;
      }, []);

      if (this.groupedResponseData.length) {
        this.dispatch('reportDialog', Position.end, {
          additionalProps: this.additionalProps,
          reportData: _.cloneDeep(this.groupedResponseData),
          submissionData: this.props.submissionData,
          taskId: this.state.taskId,
          uploadedTargetIds
        });
      } else {
        this.dispatch('closePreviousWindow', Position.end);
      }
    }
  };


}

export default UploadDialog;
